import { render, staticRenderFns } from "./SetComponentItem.vue?vue&type=template&id=40dd6c44"
import script from "./SetComponentItem.vue?vue&type=script&lang=js"
export * from "./SetComponentItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports